module.exports = __webpack_public_path__ + "static/img/dm.46f58d40.svg";